export default __webpack_public_path__ + "static/media/revenue.e2a991ba.svg";